// Logobar is now a minimal-mode PublicNav (logo-only on small pages)
import PublicNav from './PublicNav'
import React from 'react'
export default function Logobar() {
    return <PublicNav minimal={true} />
}
